/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObjectDto } from '../models';
/**
 * TestActivityReportApi - axios parameter creator
 * @export
 */
export const TestActivityReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a human-readable PDF report describing every action a participant performed during a test term: question navigation, answer submissions, answer changes, rejected save attempts, finalize clicks, and timing details. Built from `test_answer_submission_log`. Available also for IN_PROGRESS executions. 
         * @summary Get test term participant activity report (PDF)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestTermParticipantActivityReport: async (certificationId: number, stageId: number, termId: number, employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getTestTermParticipantActivityReport', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getTestTermParticipantActivityReport', 'stageId', stageId)
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('getTestTermParticipantActivityReport', 'termId', termId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getTestTermParticipantActivityReport', 'employeeId', employeeId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/terms/{termId}/participants/{employeeId}/activity-report`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"termId"}}`, encodeURIComponent(String(termId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestActivityReportApi - functional programming interface
 * @export
 */
export const TestActivityReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestActivityReportApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a human-readable PDF report describing every action a participant performed during a test term: question navigation, answer submissions, answer changes, rejected save attempts, finalize clicks, and timing details. Built from `test_answer_submission_log`. Available also for IN_PROGRESS executions. 
         * @summary Get test term participant activity report (PDF)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestTermParticipantActivityReport(certificationId: number, stageId: number, termId: number, employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestTermParticipantActivityReport(certificationId, stageId, termId, employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestActivityReportApi.getTestTermParticipantActivityReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestActivityReportApi - factory interface
 * @export
 */
export const TestActivityReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestActivityReportApiFp(configuration)
    return {
        /**
         * Returns a human-readable PDF report describing every action a participant performed during a test term: question navigation, answer submissions, answer changes, rejected save attempts, finalize clicks, and timing details. Built from `test_answer_submission_log`. Available also for IN_PROGRESS executions. 
         * @summary Get test term participant activity report (PDF)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestTermParticipantActivityReport(certificationId: number, stageId: number, termId: number, employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getTestTermParticipantActivityReport(certificationId, stageId, termId, employeeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestActivityReportApi - interface
 * @export
 * @interface TestActivityReportApi
 */
export interface TestActivityReportApiInterface {
    /**
     * Returns a human-readable PDF report describing every action a participant performed during a test term: question navigation, answer submissions, answer changes, rejected save attempts, finalize clicks, and timing details. Built from `test_answer_submission_log`. Available also for IN_PROGRESS executions. 
     * @summary Get test term participant activity report (PDF)
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestActivityReportApiInterface
     */
    getTestTermParticipantActivityReport(certificationId: number, stageId: number, termId: number, employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

}

/**
 * TestActivityReportApi - object-oriented interface
 * @export
 * @class TestActivityReportApi
 * @extends {BaseAPI}
 */
export class TestActivityReportApi extends BaseAPI implements TestActivityReportApiInterface {
    /**
     * Returns a human-readable PDF report describing every action a participant performed during a test term: question navigation, answer submissions, answer changes, rejected save attempts, finalize clicks, and timing details. Built from `test_answer_submission_log`. Available also for IN_PROGRESS executions. 
     * @summary Get test term participant activity report (PDF)
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestActivityReportApi
     */
    public getTestTermParticipantActivityReport(certificationId: number, stageId: number, termId: number, employeeId: string, options?: RawAxiosRequestConfig) {
        return TestActivityReportApiFp(this.configuration).getTestTermParticipantActivityReport(certificationId, stageId, termId, employeeId, options).then((request) => request(this.axios, this.basePath));
    }
}

